import { DateTime } from "luxon";

export const formatDate = (timezone: string, isoDate?: string) =>
  isoDate
    ? DateTime.fromISO(isoDate)
        .setZone(timezone)
        .toLocaleString(DateTime.DATE_MED)
    : "";
